import { MonthPipe } from '../../shared/pipes/month.pipe'

export function month ( monthPipe : MonthPipe ) {
  return ( month : number ) : string => monthPipe.transform(month);
}
